import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import arrowLeft from "./../../assets/images/arrow-left.svg";
import ProfileDashboard from "./components/ProfileDashboard";
import { trackZymedEvent, ZYMED_EVENTS } from "../../utils/zymedAnalytics";

const Account = () => {
  const navigate = useNavigate();

  useEffect(() => {
    trackZymedEvent(ZYMED_EVENTS.HOME_ACCOUNT_SCREEN_VIEWED);
  }, []);

  const backBtnHandler = () => {
    navigate('/');
  };

  return (
    <>
      <div className="border-b border-[#EAECF0] sticky top-0 bg-white z-[10]">
        <div className="flex items-start font-semibold gap-x-2 p-6">
          <img
            height={22}
            width={22}
            src={arrowLeft}
            alt="arrow-left"
            onClick={backBtnHandler}
            loading="lazy"
          />
          <span>Account</span>
        </div>
      </div>
      <div className="bg-[#F9F9FF] h-screen">
        <ProfileDashboard />
      </div>
    </>
  );
};

export default Account;
